var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.me)?_c('div',{staticClass:"control-panel"},[_c('div',{staticClass:"menu-items"},_vm._l((_vm.buttons),function(button){return _c('MenuButton',{key:button.label,attrs:{"icon":button.icon,"badgeCount":button.badgeCount,"label":button.label,"selected":button.selected},on:{"click":button.action}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }